import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import Component from '../Component';

class Loader extends Component {
  componentDidMount() {
    const loaded = sessionStorage.getItem('loaded', true);
    let pageStatus = null;
    let progress = null;
    let animationInterval = 33;
    const loader = this.root;
    const loadPercent = this.root.querySelector('#load_percent');

    window.document.addEventListener('readystatechange', () => {
      if (document.readyState === 'complete') {
        pageStatus = 'complete';
      }
    }, false);

    function updateProgress() {
      if (pageStatus === 'complete') {
        loadPercent.innerHTML = 100 + '%';
        setTimeout(() => {
          loadPercent.style.opacity = '0';
        }, 700);
        loader.classList.add('loaded');
        enableBodyScroll(loader);
        sessionStorage.setItem('loaded', true);
      } else {
        if (progress == null) {
          progress = 1;
        }

        progress += 1;
        if (progress >= 0 && progress <= 30) {
          animationInterval += 1;
          loadPercent.innerHTML = progress + '%';
        } else if (progress > 30 && progress <= 60) {
          animationInterval += 2;
          loadPercent.innerHTML = progress + '%';
        } else if (progress > 60 && progress <= 80) {
          animationInterval += 3;
          loadPercent.innerHTML = progress + '%';
        } else if (progress > 80 && progress <= 90) {
          animationInterval += 4;
          loadPercent.innerHTML = progress + '%';
        } else if (progress > 90 && progress <= 95) {
          animationInterval += 80;
          loadPercent.innerHTML = progress + '%';
        } else if (progress > 95 && progress <= 99) {
          animationInterval += 150;
          loadPercent.innerHTML = progress + '%';
        } else if (progress >= 100) {
          loadPercent.innerHTML = 99 + '%';
        }
        setTimeout(updateProgress, animationInterval);
      }
    }

    if (!loaded) {
      const intervalObject1 = setInterval(() => {
        const element = document.querySelector('.loader');

        if (element !== undefined) {
          disableBodyScroll(loader);
          clearInterval(intervalObject1);
          updateProgress();
        }
      }, 50);
    } else {
      loader.classList.add('no-loader');
    }
  }
}

export default Loader;
